import { FC } from "react"
import { Typography } from "@mui/material"

import { IBasemapConfig } from "services/venue"
import { resolveBasemapConfig } from "./constants"

type BasemapAttributionProps = {
  basemap?: IBasemapConfig
}

export const BasemapAttribution: FC<BasemapAttributionProps> = ({
  basemap,
}) => {
  const resolved = resolveBasemapConfig(basemap)

  if (resolved.enabled === false) return null
  if (!resolved.attribution?.trim()) return null

  return (
    <Typography
      variant="caption"
      sx={{
        position: "absolute",
        right: 4,
        bottom: 4,
        zIndex: 1,
        px: 0.5,
        color: "rgba(0, 0, 0, 0.6)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        fontSize: "10px",
        lineHeight: 1.4,
        pointerEvents: "none",
      }}
    >
      {resolved.attribution}
    </Typography>
  )
}
